import { render, staticRenderFns } from "./newheader.vue?vue&type=template&id=b76bff12&scoped=true&"
import script from "./newheader.vue?vue&type=script&lang=js&"
export * from "./newheader.vue?vue&type=script&lang=js&"
import style0 from "./newheader.vue?vue&type=style&index=0&id=b76bff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76bff12",
  null
  
)

export default component.exports